export interface Offset {
  x: number;
  y: number;
}

export default (element: HTMLElement, offset: Offset = { x: 0, y: 0 }) => {
  const rect = element.getBoundingClientRect();

  const intersectionWidth = Math.max(
    Math.min(rect.right - offset.x, window.innerWidth) - Math.max(rect.left - offset.x, 0),
    0,
  );

  const intersectionHeight = Math.max(
    Math.min(rect.bottom - offset.y, window.innerHeight) - Math.max(rect.top - offset.y, 0),
    0,
  );

  return intersectionWidth * intersectionHeight;
};
